<div  class="my-4 clearfix step-container" >
    <h4 class="step-title">Step selection</h4>
    <div #stepContainer class="col-12 px-0 example-container pt-3" (window:resize)="onResize($event)">
        <div class="d-flex col-3" *ngIf="sopStepsList.length == 0">
            <div class="create-sop-line">
                <button class="k-button" (click)="addStepAtEnd()"><mat-icon outline>add</mat-icon></button>
            </div>
        </div>
        <div id="sop-step-{{i + 1}}" class="d-flex col-3 sop-card" *ngFor="let item of sopStepsList;let i = index">
            <div class="create-sop-line" *ngIf="isDesktop && !blockCAChanges && i != sopStepsList.length">
                <button class="k-button" (click)="addStepBeforeIndex(i)"><mat-icon outline>add</mat-icon></button>
            </div>
            <div class="horz-Line" *ngIf="shouldShowRightLine(i)" style="top: 115px; width: 100%"></div>
            <div class="horz-Line vert" *ngIf="shouldShowBottomRowLine(i)" style="top: 100%; width: 100%"></div>
            <div #positioningTarget class="d-flex col-auto pr-0">
                <div class="vertical-line up" *ngIf="shouldShowVerticalUpLine(i)" style="left: 53%;"></div>
                <div class="vertical-line" *ngIf="shouldShowVerticalDownLine(i)" style="height: 90%; top: 11%; left: 53%;"></div>

                <div class="single-sop-box card-task" (click)="item.isInvalid = undefined; editStep($event, i, item)" [ngClass]="blockCAChanges?'disabled':''" [ngClass]="(item.isInvalid ? 'isinvalid' : '')">
                    <div class="card-task-media">
                        <img [ngClass]="[(item.stepImage)?'svg img-fluid':'',(item.stepCards[(item.useStepImage)?item.useStepImage:0].isInstitutionImage)?'imgFilter':'']"
                         [src]="(item.stepImage)?layoutService.serverUrl+item.stepImage:'assets/img/fallback-img.png'"
                         (error)="errImg($event)">
                        <span *ngIf="item.stepType" class="multiImage"></span>
                        <span *ngIf="!item.stepType && item.stepCards[0].handDisinfection" class="noSterlity"></span>
                    </div>
                    <div class="card-task-content" [ngClass]="(!item.stepType && item.stepCards[0].hygieneRelevantStep)?'handDisinfy':''">
                        <p class="card-task-desc" *ngIf="!item.stepType">
                            {{layoutService.translateText(item.stepCards[0].stepTittle, 'SOP_MANAGEMENT.TEXT_HERE') | labelSanitizer}}
                        </p>
                        <p class="card-task-desc" *ngIf="item.stepType">
                            {{layoutService.translateText(item.stepName, 'SOP_MANAGEMENT.TEXT_HERE') | labelSanitizer }}</p>
                    </div>
                </div>
            </div>
            <div class="create-sop-line" *ngIf="isDesktop && !blockCAChanges && i == sopStepsList.length - 1">
                <button class="k-button" (click)="addStepAtEnd()"><mat-icon outline>add</mat-icon></button>
            </div>
        </div>
        
    </div>
</div>